const STATUS_LABEL_CLASS = {
    Open: 'is-open',
    Resolved: 'is-resolved',
    Archived: 'is-archived',
};

const MobileSupportRequestCard = ({ request, replyInfo, formatDate, onOpen }) => {
    const status = request.status || 'Open';
    const statusClass = STATUS_LABEL_CLASS[status] || 'is-open';
    const description = request.comment || '';

    return (
        <button
            type="button"
            className="mobile-support-card"
            onClick={onOpen}
            aria-label={`View support request #${request.ticketId}`}
        >
            <div className="mobile-support-card__header">
                <span className="mobile-support-card__id">#{request.ticketId}</span>
                <span className={`mobile-support-card__status ${statusClass}`}>
                    <span className="mobile-support-card__status-dot" aria-hidden="true" />
                    {status}
                </span>
            </div>
            <p className="mobile-support-card__type">{request.ticketClass}</p>
            <h4 className="mobile-support-card__title">{request.businessPurpose || '—'}</h4>
            {description && <p className="mobile-support-card__excerpt">{description}</p>}
            <div className="mobile-support-card__meta">
                <span>{formatDate(request.createdAt)}</span>
                <span>
                    {replyInfo.count === 0 ? 'No replies' : `${replyInfo.count} ${replyInfo.count === 1 ? 'reply' : 'replies'}`}
                    {replyInfo.hasNew && <span className="badge rounded-pill ms-1 badge-new">NEW</span>}
                </span>
            </div>
        </button>
    );
};

export default MobileSupportRequestCard;
